<template>
  <div class="wape">
    <inside-header title="工单" righ-link-name="TeacherWorksheetPost" back-link-name="TeacherIndex"
      right-link-label="新建" />
    <div class="order-list">
      <div class="item">
        <div :class="status === 'all' ? 'active' : ''" @click="filterStatus('all')">
          全部
        </div>
      </div>
      <div class="item">
        <div :class="status === 'Open' ? 'active' : ''" @click="filterStatus('Open')">
          进行中
        </div>
      </div>
      <div class="item">
        <div :class="status === 'AdminReply' ? 'active' : ''" @click="filterStatus('AdminReply')">
          已回复
        </div>
      </div>
      <div class="item">
        <div :class="status === 'Close' ? 'active' : ''" @click="filterStatus('Close')">
          已关闭
        </div>
      </div>
    </div>
    <div class="main">
      <div v-for="(item, index) in list" :key="index" class="put" @click="goOrderDetails(item.id)">
        <div class="tile-first">
          {{ item.title }}
        </div>
        <div class="tile-second">
          {{ item.content }}
        </div>
        <a-divider />
        <div class="tile-fourth">
          问题分类：{{ item.type }}
        </div>
        <div class="tile-fifth">
          <div class="left">
            提交时间：{{ item.create_time | dayFormat }}
          </div>
          <div class="right">
            <span>{{ item.status | filterStatus }}</span>
          </div>
        </div>
      </div>
      <van-empty v-if="list.length === 0" description="暂无数据" />
      <div v-if="list.length > 0" class="pagination">
        <van-pagination v-model="currentPage" :total-items="totalItems" :items-per-page="10" @change="pageChange" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { InsideHeader, MainFooter } from '@/components'
export default {
  name: 'TeacherWorkOrder', // 当被用做组件时必须要name值
  components: {
    InsideHeader,
    MainFooter
  },
  filters: {
    // 将当前的值传进来，然后处理并将返回值传出去,filters处理英文转为中文等值不符合规矩的函数
    filterStatus(val) {
      if (val === 'Open') {
        return '进行中'
      } else if (val === 'AdminReply') {
        return '已回复'
      } else if (val === 'UserReply') {
        return '待回复'
      } else {
        return '已关闭'
      }
    }
  },
  props: {
    page: {},
    status: {
      default: 'all'
    }
  },
  data() {
    return {
      currentPage: 1,
      totalItems: '',
      list: []
    }
  },
  watch: {
    // url改变，重新加载数据
    $route() {
      this.loadData(this.page, this.status)
    }
  },
  created() {
    this.loadData(this.page, this.status)
  },
  methods: {
    loadData(page, status) {
      this.$http({
        url: 'index/worksheet/list',
        method: 'get',
        params: {
          page: page,
          status: status
        }
      }).then(res => {
        console.log(1, res)
        var data = res.data
        this.list = data.list
      })
    },
    filterStatus(target) {
      //   this.status = target
      //   this.loadData(1, target)
      this.$router.push({ name: 'TeacherWorkOrder', query: { status: target } })
    },
    pageChange(value) {
      this.currentPage = value
      this.$router.push({ name: 'TeacherWorkOrder', query: { page: value } })
    },
    goOrderDetails(id) {
      this.$router.push({ name: 'TeacherWorkOrderDetails', params: { id: id } })
    }
  }
}
</script>
<style scoped lang="stylus">
.wape{
    min-width: 280px;
    max-width: 420px;
    background-color: #fff;
        .order-list{
            box-shadow: 1px 2px 5px 0px rgba(200, 200, 200, 0.24);
            overflow:hidden;
            padding-bottom: 10px;
            .item{
                width: 20%;
                float: left;
                text-align:center;
                div:nth-child(1){
                    width:45px;
                    margin:auto;
                }
                .active {
                    border-bottom: 2px solid $theme-color;
                }
            }
        }
        .main{
        padding:0 15px;
        .put{
            padding: 30px 15px;
            border-radius: 10px;
            margin-top: 20px;
            overflow:hidden;
            box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
            .tile-first{
                font-family: PingFang-SC-Bold;
                font-size: 16px;
                color: #333333;
            }
            .tile-second{
                margin-top: 10px;
                font-size: 12px;
                color: #999999;
            }
            .tile-fourth{
                font-size: 12px;
                color:#999999;
            }
            .tile-fifth {
                overflow:hidden;
                margin-top:10px;
                .left {
                    float: left;
                    color: #999999;
                    font-size: 12px;
                }
                .right{
                    float: right;
                    width:60px;
                    height:20px;
                    background-color: #def4e4;
                    border-radius: 10px;
                    font-size: 12px;
                    color: #5bc979;
                    text-align:center;
                    line-height: 20px;
                }
            }
        }
    }
    .pagination {
        margin-top: 15px;
    }
}
</style>
